import { defineMessages } from 'react-intl';

export default defineMessages({
  closeOrderDetailsButtonAriaLabel: {
    defaultMessage: 'Close Order Details',
    description: 'Label for button that closes order details',
    id: 'TEzXGm',
  },
  customizeLayoutToggle: {
    defaultMessage: 'Customize',
    description: 'Label for toggle to customize the layout of the ui',
    id: 'iyFHhc',
  },
  restoreDefaults: {
    defaultMessage: 'Restore Defaults',
    description: 'Button to restore the order details layout to default settings',
    id: 'W9Z2VM',
  },
});
